import { applyUserTranslationsAllTypes } from "@/lib/utils";
import type {
  OtrosProyectos,
  OtrasActuaciones,
  OtrasTransacciones,
} from "@/types/models/otros";
import { otrosRepository } from "../repositories/otros.repository";
import { mapOtrosProyectosWithRelations } from "../mappers/otros.mappers";

export const otrosService = {
  async fetchOtrosProyectosByTenant(params: {
    tenantId: number;
    userLang: string;
  }): Promise<OtrosProyectos[]> {
    const [proyectosData, actuacionesData, transaccionesData] =
      await Promise.all([
        otrosRepository.fetchOtrosProyectosByTenant(params.tenantId),
        otrosRepository.fetchOtrasActuacionesByTenant(params.tenantId),
        otrosRepository.fetchOtrasTransaccionesByTenant(params.tenantId),
      ]);

    const proyectos = applyUserTranslationsAllTypes(
      proyectosData ?? [],
      params.userLang,
      ["nombre", "observaciones"]
    );

    const actuaciones = applyUserTranslationsAllTypes(
      actuacionesData ?? [],
      params.userLang,
      ["nombre", "descripcion"]
    );

    return mapOtrosProyectosWithRelations({
      proyectos,
      actuaciones,
      transacciones: transaccionesData ?? [],
    });
  },

  async fetchOtrasActuacionesByTenant(params: {
    tenantId: number;
    userLang: string;
  }): Promise<OtrasActuaciones[]> {
    const data = await otrosRepository.fetchOtrasActuacionesByTenant(
      params.tenantId
    );

    return applyUserTranslationsAllTypes(
      data ?? [],
      params.userLang,
      ["nombre", "descripcion"]
    );
  },

  async fetchOtrasTransaccionesByTenant(params: {
    tenantId: number;
  }): Promise<OtrasTransacciones[]> {
    return (
      (await otrosRepository.fetchOtrasTransaccionesByTenant(params.tenantId)) ??
      []
    );
  },

  createOtroProyecto: otrosRepository.createOtroProyecto,
  updateOtroProyecto: otrosRepository.updateOtroProyecto,
  deleteOtroProyecto: otrosRepository.deleteOtroProyecto,

  createOtraActuacion: otrosRepository.createOtraActuacion,
  updateOtraActuacion: otrosRepository.updateOtraActuacion,
  deleteOtraActuacion: otrosRepository.deleteOtraActuacion,

  createOtraTransaccion: otrosRepository.createOtraTransaccion,
  updateOtraTransaccion: otrosRepository.updateOtraTransaccion,
  deleteOtraTransaccion: otrosRepository.deleteOtraTransaccion,
};